module.exports = __webpack_public_path__ + "static/media/eye-show.721a35f7.svg";